import { BreakPointCondition, SliderModal, useBreakpointIf, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { ErrorListResponse, instanceOfErrorListResponse } from '@genial/services';
import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import { useEffect } from 'react';

import { useRecoilQuery } from '../../hooks/useRecoilQuery';
import { useToastCreator } from '../../hooks/useToastCreator';
import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../routes/types';
import { batchTicketCustomerBasketDetailsQuery } from '../../store/batchTicketDetail/selector';

import { BatchDetails } from './components/BatchDetails';
import { BatchDetailsLoading } from './components/BatchDetailsLoading';
import { defaultErrorMessage } from './constants';

export const BatchTicketDetail = () => {
  const { showToast, showToastFromError } = useToastCreator('batch-ticket-details');
  const { params: routeParams } =
    useRoute<RouteProp<SignedInRootStackParamList, 'BatchTicketDetail'>>();
  const { goBack, canGoBack, navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const isMobile = useBreakpointIf(BreakPointCondition.EqualOrDown, 'sm');
  const isTablet = useBreakpointIf(BreakPointCondition.EqualOrDown, 'lg');

  const handleCloseDetails = () => {
    if (canGoBack()) {
      return goBack();
    }
    navigate('BatchTicketRequests');
  };

  const { basketAdvisorOrderId } = routeParams;

  if (!basketAdvisorOrderId) {
    handleCloseDetails();
  }

  const {
    data: customerBasketDetailsData,
    error,
    loading: isLoading,
  } = useRecoilQuery(batchTicketCustomerBasketDetailsQuery({ basketAdvisorOrderId }), {
    cachePolicy: 'no-cache',
  });

  const customerBasketDetails = customerBasketDetailsData?.data;

  const batchDetailsItem = customerBasketDetails;

  const handleShowErrorToast = (errorToShow: Error) => {
    if (errorToShow && instanceOfErrorListResponse(errorToShow)) {
      (error as unknown as ErrorListResponse)?.errors?.forEach((errorItem) =>
        showToastFromError(errorItem)
      );
      return;
    }

    showToast(...defaultErrorMessage);
  };

  useEffect(() => {
    if (!error) {
      return;
    }
    handleShowErrorToast(error);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  return (
    <SliderModal
      onDismiss={handleCloseDetails}
      width={isMobile || isTablet ? 1 : 0.9}
      dismissWhenClickOutside>
      <VStack pt={Spacing['inline.xxs']} flex={1} space={Spacing['inline.xxxs']}>
        {batchDetailsItem && !isLoading && (
          <BatchDetails
            item={batchDetailsItem}
            handleCloseDetails={handleCloseDetails}
            handleShowErrorToast={handleShowErrorToast}
          />
        )}
        {isLoading && <BatchDetailsLoading handleCloseDetails={handleCloseDetails} />}
      </VStack>
    </SliderModal>
  );
};
